import { ArrowUpRight } from "lucide-react";
import React, { useEffect } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { NavLink } from "react-router-dom";

const HomeOfferings = () => {

    useEffect(() => {
        const details = gsap.utils.toArray(".panel-text:not(:first-child)")
        const photos = gsap.utils.toArray(".panel:not(:first-child)")

        gsap.set(photos, { autoAlpha: 0 })
        const allPhotos = gsap.utils.toArray(".panel")

        // create
        let mm = gsap.matchMedia();
        mm.add("(min-width: 600px)", () => {
            ScrollTrigger.create({
                trigger: ".serviceSection",
                start: "top top",
                end: "bottom bottom",
                pin: ".imagearea"
            })
            details.forEach((detail, index) => {
                let headline = detail.querySelector("h2")
                let animation = gsap.timeline()
                    .to(photos[index], { autoAlpha: 1 })
                    .set(allPhotos[index], { autoAlpha: 0 })
                ScrollTrigger.create({
                    trigger: headline,
                    start: "top 80%",
                    end: "top 50%",
                    animation: animation,
                    scrub: true,
                    markers: false
                })
            })
            return () => { };
        });

    }, [])

    return (
        <section className="">
            <div className="serviceSection serviceSection__area">
                <div className="tw-container tw-mx-auto">
                    <div className="tw-flex tw-flex-wrap tw--mx-3">
                        <div className="tw-w-full tw-px-3 lg:tw-w-1/2">
                            <div className="text-wrap serviceSection__area__content">
                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Build</span>
                                        <h2>Software & Product Development</h2>
                                        <p className="mt-4">
                                            We build web applications with React 19, Angular, Next.js, Tailwind CSS, and shadcn/ui, and mobile apps with React Native, Flutter, and native Android & iOS.
                                        </p>
                                    </div>
                                    <NavLink to="/software-product-development" className="btn-more" aria-label="Explore Software & Product Development">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>

                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Build</span>
                                        <h2>Python & Backend Development</h2>

                                        <p className="mt-4">
                                            Python applications, REST APIs, FastAPI & Django, backend architecture, and business automation, engineered for reliability.
                                        </p>
                                    </div>
                                    <NavLink to="/python-backend-development" className="btn-more" aria-label="Explore Python & Backend Development">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>

                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Intelligence</span>
                                        <h2>AI & Intelligent Automation</h2>

                                        <p className="mt-4">
                                            Generative AI, AI chatbots, AI agents, RAG applications, and document AI/OCR that automate real business workflows.
                                        </p>
                                    </div>
                                    <NavLink to="/ai-automation" className="btn-more" aria-label="Explore AI & Intelligent Automation">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>

                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Data</span>
                                        <h2>Database & Data Solutions</h2>

                                        <p className="mt-4">
                                            PostgreSQL and SQL database architecture, optimization, data migration, and reporting & analytics you can rely on.
                                        </p>
                                    </div>
                                    <NavLink to="/database-data-solutions" className="btn-more" aria-label="Explore Database & Data Solutions">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>

                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Design</span>
                                        <h2>UI/UX & Product Design</h2>

                                        <p className="mt-4">
                                            Research-driven UX, wireframes, UI design, and design systems that create intuitive, engaging digital experiences.
                                        </p>
                                    </div>
                                    <NavLink to="/UIUX" className="btn-more" aria-label="Explore UI/UX & Product Design">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>

                                <div className="panel-text">
                                    <div className="section__title section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
                                        <span>Growth</span>
                                        <h2>Digital Marketing & SEO</h2>

                                        <p className="mt-4">
                                            SEO, local SEO, Google Ads, social media and content marketing, and lead generation that grows your pipeline.
                                        </p>
                                    </div>
                                    <NavLink to="/digital-marketing-seo" className="btn-more" aria-label="Explore Digital Marketing & SEO">
                                        <span className="btn-text">Explore</span>
                                        <span className="btn-icon" aria-hidden="true">
                                            <ArrowUpRight size="16px" className="icon" />
                                        </span>
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="tw-w-full tw-px-3 lg:tw-w-1/2 tw-relative">
                            <div className="imagearea">
                                <div className="p-wrap serviceSection__area__image">
                                    <div className="panel" style={{ background: `url(assets/img/offerings/Product_Development.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                    <div className="panel" style={{ background: `url(assets/img/offerings/Software_Development.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                    <div className="panel" style={{ background: `url(assets/img/offerings/CMS.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                    <div className="panel" style={{ background: `url(assets/img/offerings/Testing.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                    <div className="panel" style={{ background: `url(assets/img/offerings/UIUX.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                    <div className="panel" style={{ background: `url(assets/img/offerings/IT_Support.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </section>
    )
};

export default HomeOfferings;
